import React from 'react';
import { Box, Text, Heading, ButtonPrimary } from '@primer/components'
import { Link } from "react-router-dom";
import LazyLoad from 'react-lazyload';

import Masonry from '../../../components/BeforeAfter/Masonry'

import * as constants from '../../../constants'
import { useCategory } from '../../../hooks/useCorpus'

export default function(props) {
  return (
    <Box className="position-relative pt-md-6 pt-4 pl-4 pr-4">
      <Box id="security">
        <Box alignItems="center" className="container-lg clearfix d-md-flex mb-4 mb-md-0" id="features">
          <Box className="col-md-12  pb-4">
            <Heading>Prevent bugs</Heading>
            <Text className="f3">Protect your codebase against adding code likely to cause hard-to-debug defects including missing commas, accidentally committed debug code, and more.</Text>.
          </Box>
        </Box>
        <Box className="container-lg" style={{maxWidth:1130}}>
          <Masonry corpus={useCategory(constants.CATEGORY_INTRODUCE_BUGS)} showLabels={false} />
        </Box>
      </Box>

      <Box id="performance">
        <Box alignItems="center" className="container-lg clearfix d-md-flex mb-4 mb-md-0 mt-4">
          <Box className="col-md-12 pb-4">
            <Heading>Improve the quality of your unit tests</Heading>
            <Text className="f3">Protect against suboptimal unit tests that reduce your ability to detect and fix bugs in your codebase.</Text>
          </Box>
        </Box>
        <Box className="container-lg" style={{maxWidth:1130}}>
          <Masonry corpus={useCategory(constants.CATEGORY_TESTS)} showLabels={false} />
        </Box>
      </Box>

      <Box id="maintainability">
        <Box alignItems="center" className="container-lg clearfix d-md-flex mb-4 mb-md-0">
          <Box className="col-md-12  pb-4">
            <Heading>Ensure maintainability best practices</Heading>    
            <Text className="f3">Preventing tech debt including obsolete code, unnecessarily complex code, typos, and more.</Text>.
          </Box>
        </Box>
        <Box className="container-lg" style={{maxWidth:1130}}>
          <Masonry corpus={useCategory(constants.CATEGORY_MAINTAINABILITY)} />
        </Box>
      </Box>
    </Box>
  );
}
